import HiveLoader from 'utils/hive_loader';

// TODO we should bind these events with a custom Vue wrapper
$(document).on('click', '.js-show-loader', () => HiveLoader.show());

$(document).on('submit', 'form.js-add-to-basket-form', () => HiveLoader.show());

$(document).on('submit', 'form.js-show-hive-loader-on-submit', () => HiveLoader.show());
